export default {
    isFocused: false,
    isEmpty: true
}
